import { IOpenWithFaireCreditOfferRange } from '@faire/web-api--source/indigofair/data/IOpenWithFaireCreditOfferRange';
import { IRetailer } from '@faire/web-api--source/indigofair/data/IRetailer';
import { SettingConst } from '@faire/web-api--source/types';

/**
 * TBD
 */
export const OPEN_WITH_FAIRE_OFFERED_TERMS =
  'OPEN_WITH_FAIRE_OFFERED_TERMS' as SettingConst<
    'OPEN_WITH_FAIRE_OFFERED_TERMS',
    Partial<
      Record<
        keyof typeof IRetailer.BusinessCategory,
        IOpenWithFaireCreditOfferRange
      >
    >,
    'RETAILER' | 'VISITOR_WEB'
  >;
